import React from "react";
import { Button } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const FontSizeH2 = styled.div`
  font-size: calc(1.3rem + .6vw);
`;
const EbusMobileIntroduction = (props) => {
  const downloadFile = () => {
    window.location.href = "https://ebus.ir/ebus.apk";
  };

  const history = useHistory();

  return (
    <div className="row">
      <div className="col-sm-6">
        <div style={{ marginLeft: 5, marginTop: "60%" }}>
          <FontSizeH2>دانلود اپلیکیشن ای باس</FontSizeH2>
          <p style={{ color: "gray" }}>راحت تر از همیشه سفر کنید</p>
          <Button
            onClick={downloadFile}
            className="btn  mt-1"
            style={{
              backgroundColor: "#6dd06d",
              height: 50,
              color: "white",
              width: "100%",
              borderRadius: 13,
            }}
            onClick={() => {
              history.push("/MobileIntro");
            }}
          >
            <i
              className="fa fa-mobile-alt"
              style={{ marginLeft: 5, color: "white" }}
            ></i>
            <span style={{ fontSize: 20 }}>
              <b>دانلود اپلیکیشن ایباس</b>
            </span>
          </Button>
        </div>
      </div>
      <div className="col-sm-6">
        <img
          src={toAbsoluteUrl("media/ebusHomePics/Mask Group 3.webp")}
          alt="mask-group"
          width="100%"
          height="100%"
        />
      </div>
    </div>
  );
};

export default EbusMobileIntroduction;
